import React, { useEffect, useState } from "react";
import { Phone, MessageCircle, Rocket } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";
import { waLink, telLink } from "../lib/contact";

export default function MobileCTABar({ onOpenLead }) {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  // Show only after the user has scrolled past the hero so it doesn't fight for attention on first paint
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 px-3 pointer-events-none transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
      }`}
      style={{ paddingBottom: "calc(0.5rem + env(safe-area-inset-bottom))" }}
      data-testid="mobile-cta-bar"
    >
      <div className="pointer-events-auto mx-auto max-w-md flex items-center gap-1.5 p-1.5 rounded-full bg-slate-950/85 backdrop-blur-xl border border-white/10 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.5)]">
        <a
          href={telLink()}
          data-testid="mobile-cta-call"
          className="flex items-center justify-center w-10 h-10 rounded-full bg-white/10 active:bg-white/20 text-white"
          aria-label={t.sticky.call}
        >
          <Phone className="w-4 h-4" />
        </a>
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-cta-whatsapp"
          className="flex items-center justify-center w-10 h-10 rounded-full bg-emerald-500 active:bg-emerald-600 text-white"
          aria-label={t.sticky.whatsapp}
        >
          <MessageCircle className="w-4 h-4" />
        </a>
        <button
          onClick={onOpenLead}
          data-testid="mobile-cta-launch"
          className="flex-1 h-10 rounded-full bg-gradient-to-r from-blue-500 to-violet-500 text-white font-semibold text-[13px] flex items-center justify-center gap-1.5 active:opacity-90"
        >
          <Rocket className="w-3.5 h-3.5" />
          {t.sticky.launch}
        </button>
      </div>
    </div>
  );
}
